export default "__VITE_ASSET__CsZ9OkCG__"